import { render, staticRenderFns } from "./ObiThemePreview.vue?vue&type=template&id=25faa8b6&scoped=true&"
import script from "./ObiThemePreview.vue?vue&type=script&lang=js&"
export * from "./ObiThemePreview.vue?vue&type=script&lang=js&"
import style0 from "./ObiThemePreview.vue?vue&type=style&index=0&id=25faa8b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25faa8b6",
  null
  
)

export default component.exports